/* eslint-disable array-callback-return */
import { postCommunicationInfo, updateCommunicationInfo } from '../store/actions/authorizations.actions';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React from 'react';
import NotesAndCommunicationEditableCard from './notesAndCommunicationEditableCard.component';

const NotesAndCommunication = (props) => {

  const commentsAndNotes = props.commentsAndNotes ? props.commentsAndNotes : [];

  return (
    <NotesAndCommunicationEditableCard
      comments={commentsAndNotes}
      numColumns={2} 
      authorizationId={props.id}
      enumerations={props.enumerations}
      isReadOnly={Boolean(props.isReadOnly)}
    />
  );

};

export default compose(
  connect(null, {
    postCommunicationInfo,
    updateCommunicationInfo,
    showToast,
  }),
)(NotesAndCommunication);